import { JsonApiClient } from "@/modules/api/utils/createJsonApiClient/createJsonApiClient";
import {
  forgotPasswordResourcePath,
  forgotPasswordResourceType,
} from "@/modules/auth/api/resources/forgotPassword/forgotPasswordConsts";

export function forgotPasswordMutation(jsonApi: JsonApiClient) {
  return (attributes: { email: string }) =>
    jsonApi.createOne({
      path: forgotPasswordResourcePath,
      type: forgotPasswordResourceType,
      attributes,
    });
}
